import React from "react"

// Offset pagination controls. `range` copy is an I18n string with %{from},
// %{to}, %{total} placeholders filled here.
export function Pagination({ page, perPage, total, onPage, copy }) {
  const totalPages = Math.max(1, Math.ceil(total / perPage))
  const from = total === 0 ? 0 : (page - 1) * perPage + 1
  const to = Math.min(page * perPage, total)
  const rangeLabel = copy.pagination.range
    .replace("%{from}", from)
    .replace("%{to}", to)
    .replace("%{total}", total)

  const btn = "rounded-lg border border-gray-300 dark:border-gray-700 px-3 py-1.5 text-sm font-medium text-gray-700 dark:text-gray-300 enabled:hover:bg-gray-50 disabled:opacity-40"

  return (
    <div className="flex items-center justify-between">
      <span className="text-sm text-gray-500 dark:text-gray-400">{rangeLabel}</span>
      <div className="flex gap-2">
        <button className={btn} disabled={page <= 1} onClick={() => onPage(page - 1)}>
          {copy.pagination.prev}
        </button>
        <button className={btn} disabled={page >= totalPages} onClick={() => onPage(page + 1)}>
          {copy.pagination.next}
        </button>
      </div>
    </div>
  )
}
